import { IconNames } from "@blueprintjs/icons";
import type { IconName, ITreeNode } from "@focus/focusUI";
import { SUMType, type SUMConfig, type SUMTreeNodeData } from "../types/sum";

export function resolveIcon(config: SUMConfig, expanded?: boolean): IconName {
  if (config.type === SUMType.CONTAINER) {
    return expanded ? IconNames.FOLDER_OPEN : IconNames.FOLDER_CLOSE;
  }

  return IconNames.DOCUMENT;
}

export interface BuildTreeParams {
  values: SUMConfig[];
  collapsed: Record<string, boolean>;
  selectedId?: string;
  parentId?: string;
}

export function buildSumTree({
  values,
  collapsed,
  selectedId,
  parentId = "",
}: BuildTreeParams): ITreeNode[] {
  return values.map((config, index) => {
    const id = `${parentId}_${index}`;
    const isExpanded = !collapsed[id];

    const children =
      config.type === SUMType.CONTAINER
        ? buildSumTree({
            values: config.items ?? [],
            collapsed,
            selectedId,
            parentId: id,
          })
        : [];

    return {
      id,
      icon: resolveIcon(config, isExpanded),
      label: config.name,
      isExpanded,
      isSelected: selectedId === id,
      hasCaret: children.length > 0,
      nodeData: { ...config, id } as SUMTreeNodeData,
      childNodes: children,
    };
  });
}